import { useEffect, useRef, useState } from 'react'
import { ReactComponent as Add } from '../assets/icons/add.svg'
import { ReactComponent as CheckMarkFilled } from '../assets/icons/checkmark-filled.svg'
import { ReactComponent as Right } from '../assets/icons/board-right.svg'
import { ReactComponent as Left } from '../assets/icons/board-left.svg'
import { ReactComponent as Copy } from '../assets/icons/copy.svg'
import { ReactComponent as Delete } from '../assets/icons/delete.svg'
import { ReactComponent as Check } from '../assets/icons/checkmark.svg'
import { ReactComponent as CloseFilled } from '../assets/icons/close-filled.svg'
import Slide from './Slide'
import LoadDocument from './LoadDocument'
import {
  deleteClassRoomBoard,
  PostClassRoomBoard,
  PostClassRoomBoardMove,
  PostClassRoomBoardNewPage,
} from '../apis/classRoom.ts'
import { useLocation } from 'react-router-dom'
import LoadBoard from './LoadBoard.jsx'
import { DefaultModal } from './BoardModal.jsx'

export default function BoardSideMenuBar({
  classroomInfo,
  boardList,
  getApi,
  currentPage,
  setCurrentPage,
  setSideBarWidth,
  sideBarWidth,
  // isSideBarFold,
  // setIsSideBarFold,
  // socketEventResponse,
}) {
  const location = useLocation()
  // console.log(location.state)
  const [isSideBarFold, setIsSideBarFold] = useState(false)
  //   const [isSelected, setIsSelected] = useState(false)
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
  const [isBoardModalOpen, setIsBoardModalOpen] = useState(false)
  const [isSelectedMode, setIsSelectedMode] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isDragMode, setIsDragMode] = useState(false)
  const [targetOrder, setTargetOrder] = useState()
  const [selectedSlide, setSelectedSlide] = useState([])

  /*************** 보드 삭제 API **************/
  const deleteClassRoomBoardApi = async (deletedBoardIds) => {
    const deleteClassRoomBoardResponse = await deleteClassRoomBoard(
      { classroomId: classroomInfo.id },
      { deletedBoardIds: deletedBoardIds },
    )
    if (deleteClassRoomBoardResponse.error) {
      console.log(deleteClassRoomBoardResponse.error)
      return
    } else {
      console.log(deleteClassRoomBoardResponse.result)
      setCurrentPage(deleteClassRoomBoardResponse.data)
      await getApi()
      // setCurrentPage(currentPage + 1)
      setIsSelectedMode(false)
      setSelectedSlide([])
    }
  }

  /*************** 새 페이지 추가 API **************/
  const postClassRoomBoardNewPageApi = async (currentPage) => {
    const postClassRoomBoardNewPageResponse = await PostClassRoomBoardNewPage(
      { classroomId: classroomInfo?.id },
      {
        currentPageNumber: currentPage,
      },
    )
    if (postClassRoomBoardNewPageResponse.error) {
      console.log(postClassRoomBoardNewPageResponse.error)
      return
    } else {
      // console.log(postClassRoomBoardNewPageResponse.data)
      await getApi()
      setCurrentPage(postClassRoomBoardNewPageResponse.data)
      // setIsSelectedMode(false)
      setTargetOrder()
    }
  }
  const handleSelectClick = (id) => {
    if (!selectedSlide?.includes(id)) {
      setSelectedSlide((prev) => [...prev, id])
    } else {
      const unSelectedSlide = selectedSlide.filter((item) => item !== id)
      setSelectedSlide(unSelectedSlide)
      // getSelectedSlide(unSelectedSlide)
    }
  }

  /*************** 보드 생성 - 보드 API **************/
  const postClassRoomBoardApi = async (selectedBoardIds, currentPage) => {
    const postClassRoomBoardResponse = await PostClassRoomBoard(
      {
        classroomId: classroomInfo.id,
      },
      {
        currentPageNumber: currentPage,
        boardIds: selectedBoardIds,
      },
    )

    if (postClassRoomBoardResponse.error) {
      console.log(postClassRoomBoardResponse.error)
      return
    } else {
      console.log(postClassRoomBoardResponse.result)
      setCurrentPage(postClassRoomBoardResponse.data)
      await getApi()
      setIsSelectedMode(false)
      setTargetOrder()
    }
  }

  /*************** 보드 이동 API **************/
  const postClassRoomBoardMoveApi = async (targetNumber, selectedBoardIds) => {
    const postClassRoomBoardMoveResponse = await PostClassRoomBoardMove(
      {
        classroomId: classroomInfo.id,
      },
      {
        targetPageNumber: targetNumber,
        boardIds: selectedBoardIds,
      },
    )

    if (postClassRoomBoardMoveResponse.error) {
      console.log(postClassRoomBoardMoveResponse.error)
      return
    } else {
      await getApi()
      setCurrentPage(postClassRoomBoardMoveResponse.data)
      // setCurrentPage(getLastActiveBoard(selectedSlide[selectedSlide.length - 1]))
      // setSelectedSlide([])
    }
  }

  useEffect(() => {
    if (isSelectedMode) {
      setSelectedSlide((prev) => [
        ...prev,
        boardList?.find((item) => item.pageNum === currentPage)?.id,
      ])
      setTargetOrder(currentPage)
    } else {
      setTargetOrder()
    }
    // eslint-disable-next-line
  }, [isSelectedMode])

  const sideBarRef = useRef()

  useEffect(() => {
    function handleClickOutside(e) {
      if (isDocumentModalOpen) {
        return
      }
      if (isBoardModalOpen) {
        return
      }
      if (isDeleteModalOpen) {
        return
      }
      if (e.target.id === 'button') {
        setIsSideBarFold(true)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
    // eslint-disable-next-line
  }, [isDocumentModalOpen, isBoardModalOpen, isDeleteModalOpen])
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        !e.target.id.includes('button') &&
        sideBarRef.current &&
        !sideBarRef.current.contains(e.target)
      ) {
        setIsSideBarFold(true)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line
  }, [sideBarRef])

  const handlePageNum = (pageNum) => {
    if (pageNum > targetOrder || !targetOrder) {
      setTargetOrder(pageNum)
    } else {
      if (pageNum === targetOrder) {
        setTargetOrder()
      }
    }
  }

  useEffect(() => {
    const handleResize = () => {
      const { width } = sideBarRef.current?.getBoundingClientRect() ?? {
        width: 0,
      }
      setSideBarWidth(width)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
    // eslint-disable-next-line
  }, [isSideBarFold])

  return (
    <div
      // ref={sideBarRef}
      className={`flex items-center overflow-hidden`}
    >
      {/* sideBar Button */}
      <div
        onClick={() => setIsSideBarFold((prev) => !prev)}
        className='tab:h-60 tab:w-28 tab:rounded-l-8 board:h-[88px] board:w-40 board:rounded-l-8 absolute right-0 flex h-50 w-[22px] items-center justify-center rounded-l-4 bg-background-alternative stroke-border-active shadow-emphasize 3xl:h-120 3xl:w-[52px] 3xl:rounded-l-10'
        style={{ right: isSideBarFold ? '0px' : `${sideBarWidth}px` }}
      >
        {isSideBarFold ? (
          <Left className='tab:w-28 tab:h-28 h-32 w-32 3xl:h-[42px] 3xl:w-[42px]' />
        ) : (
          <Right className='tab:w-28 tab:h-28 h-32 w-32 3xl:h-[42px] 3xl:w-[42px]' />
        )}
      </div>
      {/* {!isSideBarFold && ( */}
      <div
        ref={sideBarRef}
        className={`${isSideBarFold ? 'w-0 translate-x-full' : 'min-w-min translate-x-0'} fixed right-0 flex h-full flex-col border-l-2 border-border-default transition-all duration-150`}
      >
        <div
          className={`scroll-bar-xs board:scroll-bar tab:pl-12 tab:pt-16 flex w-full grow flex-col items-start overflow-y-scroll bg-fill-normal pl-6 pt-8 3xl:pl-16 3xl:pt-20`}
        >
          {boardList?.map((item, index) => (
            <div
              key={index}
              onDragEnter={(e) => {
                e.preventDefault()
                if (e.target.id === 'first-order') {
                  setTargetOrder(0)
                } else {
                  setTargetOrder(item.pageNum)
                }
                setIsDragMode(true)
              }}
              onDragEnd={async (e) => {
                document.body.style.overflow = ''
                e.preventDefault()
                await postClassRoomBoardMoveApi(targetOrder, selectedSlide)
                setIsDragMode(false)
                // getLastActiveBoard(boardList, selectedSlide[selectedSlide.length - 1])
                setSelectedSlide([])
                setIsSelectedMode(false)
                const ghostElement = document.getElementById('drag-ghost')
                document.body.removeChild(ghostElement)
              }}
              className={`${isDragMode ? (targetOrder === 0 ? 'tab:pb-8 board:pb-12 pb-6 first:pb-24 first:pt-0' : item.pageNum === targetOrder ? 'pb-36' : 'tab:pb-8 board:pb-12 pb-6') : 'tab:pb-8 board:pb-12 pb-6'} ${isDragMode ? 'first:pt-12' : ''}`}
              id={'first-order'}
            >
              <div
                onDragStart={(e) => {
                  document.body.style.overflow = 'hidden'
                  if (!isSelectedMode) {
                    setSelectedSlide((prev) => [...prev, e.target.id])
                  }
                  const ghostElement = document.createElement('img')
                  ghostElement.src = item.backgroundImageUrl
                  ghostElement.style.width = '140px'
                  ghostElement.style.height = '80px'
                  ghostElement.style.borderRadius = '10px'
                  ghostElement.style.border = '2px solid #09A56F'
                  ghostElement.style.visibility = isDragMode ? 'hidden' : 'visible'
                  ghostElement.id = 'drag-ghost'
                  if (ghostElement) {
                    document.body.removeChild(ghostElement)
                  }

                  // }}
                  e.dataTransfer.setDragImage(ghostElement, 0, 0)
                }}
                id={item.id}
                className='board:h-[132px] board:w-[232px] tab:h-[128px] tab:w-[224px] h-[90px] w-[158px] rounded-10 3xl:h-[178px] 3xl:w-[314px]'
                onClick={() => {
                  if (isSelectedMode) {
                    handleSelectClick(item.id)
                    handlePageNum(item.pageNum)
                  }
                  setCurrentPage(item.pageNum)
                }}
                draggable={true}
              >
                {isDragMode && item.pageNum === 1 && targetOrder === 0 && (
                  <div className='pb-8'>
                    <div className='h-4 w-full bg-border-active' />
                  </div>
                )}
                <Slide
                  url={item.backgroundImageUrl}
                  id={item.id}
                  pageNum={item.pageNum}
                  selectedMode={isSelectedMode}
                  currentPage={currentPage}
                  selectedSlide={selectedSlide}
                  dragMode={isDragMode}
                />
                {isDragMode && item.pageNum === targetOrder && (
                  <div className='py-16'>
                    <div className='h-4 w-full bg-border-active' />
                  </div>
                )}
              </div>
            </div>
          ))}
          {/* </div> */}
        </div>
        <div className='min-h-min w-full flex-none'>
          {isSelectedMode && selectedSlide.length > 0 ? (
            <div className='tab:px-12 tab:py-10 board:py-12 flex w-full flex-col gap-12 border-t-[2px] border-border-default bg-background-default px-6 py-8 3xl:gap-20 3xl:px-16'>
              <div className='flex items-center justify-between fill-label-info'>
                <div className='tab:gap-8 flex select-none items-center gap-4 fill-primary-normal'>
                  <Check className='tab:h-24 tab:w-24 h-[18px] w-[18px] 3xl:h-32 3xl:w-32' />
                  <p className='text-caption2-medium tab:text-body2-medium text-primary-normal 3xl:text-h1-medium'>{`${selectedSlide?.length}장 선택`}</p>
                </div>
                <CloseFilled
                  onClick={() => {
                    setIsSelectedMode(false)
                    setSelectedSlide([])
                  }}
                  className='tab:h-20 tab:w-20 h-[18px] w-[18px] cursor-pointer 3xl:h-28 3xl:w-28'
                />
              </div>
              <div className='tab:gap-8 board:gap-12 flex w-full gap-4'>
                <button
                  onClick={async () => {
                    await postClassRoomBoardNewPageApi(targetOrder)
                    setIsSelectedMode(false)
                    setSelectedSlide([])
                  }}
                  className='tab:h-40 tab:rounded-8 board:rounded-10 flex h-28 w-full items-center justify-center rounded-4 bg-border-active fill-static-white hover:bg-mint-40 3xl:h-min 3xl:py-4'
                >
                  <Add className='tab:h-[38px] tab:w-[38px] h-[22px] w-[22px] 3xl:h-48 3xl:w-48' />
                </button>
                <button
                  onClick={async () => {
                    await postClassRoomBoardApi(selectedSlide, targetOrder)
                    // setCurrentPage(targetOrder + selectedSlide.length)
                    setSelectedSlide([])
                  }}
                  className='tab:h-40 tab:rounded-8 board:rounded-10 flex h-28 w-full items-center justify-center rounded-4 bg-background-secondary py-8 hover:bg-background-hover'
                >
                  <Copy className='tab:h-32 tab:w-32 h-[22px] w-[22px]' />
                </button>
                <button
                  onClick={() => {
                    setIsDeleteModalOpen(true)
                  }}
                  className={`${isDeleteModalOpen ? 'z-[1000]' : 'hover:bg-label-disable'} tab:h-40 tab:rounded-8 board:rounded-10 flex h-28 w-full items-center justify-center rounded-4 bg-background-alternative fill-label-info`}
                >
                  <Delete className='tab:h-32 tab:w-32 h-[22px] w-[22px] 3xl:h-40 3xl:w-40' />
                </button>
              </div>
            </div>
          ) : (
            <div className='board:gap-12 tab:gap-8 tab:px-12 tab:py-10 flex w-full gap-4 border-t-[2px] border-border-default bg-background-default px-6 py-8 3xl:px-16 3xl:py-12'>
              <button
                onClick={async () => {
                  await postClassRoomBoardNewPageApi(currentPage)
                  setCurrentPage(currentPage + 1)
                }}
                className='tab:h-40 tab:rounded-8 board:px-[18px] board:rounded-10 flex h-[28px] items-center justify-center rounded-4 bg-border-active fill-static-white px-[15px] py-[3px] hover:bg-mint-40 3xl:h-min 3xl:py-4'
              >
                <Add className='tab:h-[38px] tab:w-[38px] h-[22px] w-[22px] 3xl:h-48 3xl:w-48' />
              </button>
              <button
                onClick={() => setIsSelectedMode(true)}
                className='tab:py-[11px] board:py-10 tab:rounded-10 tab:gap-[5px] tab:h-min flex h-28 w-full items-center justify-center gap-2 rounded-4 bg-background-secondary fill-primary-normal py-6 hover:bg-background-hover 3xl:py-[15px]'
              >
                <CheckMarkFilled className='tab:h-[18px] tab:w-[18px] h-12 w-12 3xl:h-24 3xl:w-24' />
                <p className='text-caption2-medium tab:text-body3-medium board:text-body2-medium text-primary-normal 3xl:text-h2-medium'>
                  선택
                </p>
              </button>
            </div>
          )}
          <div className='tab:px-12 tab:pb-12 tab:pt-8 board:gap-12 tab:gap-8 box-border flex w-full gap-4 border-t-[1px] border-border-default bg-background-default px-6 pb-8 pt-6 3xl:px-16 3xl:pb-20 3xl:pt-12'>
            <button
              onClick={() => setIsDocumentModalOpen(true)}
              className='board:rounded-8 text-caption2-medium tab:rounded-8 tab:text-body3-medium board:text-body2-medium box-border flex w-full cursor-pointer items-center justify-center rounded-4 border border-primary-normal bg-static-white py-8 text-primary-normal hover:bg-fill-normal 3xl:py-[14px] 3xl:text-h2-medium'
            >
              자료 불러오기
            </button>
            <button
              onClick={() => setIsBoardModalOpen(true)}
              className='board:rounded-8 text-caption2-medium tab:rounded-8 tab:h-40 tab:text-body3-medium board:text-body2-medium box-border flex w-full cursor-pointer items-center justify-center rounded-4 border border-primary-normal bg-static-white py-8 text-primary-normal hover:bg-fill-normal 3xl:py-[14px] 3xl:text-h2-medium'
            >
              보드 불러오기
            </button>
          </div>
        </div>
      </div>
      {/* )} */}
      {isDocumentModalOpen && (
        <div className='z-[1000]'>
          <LoadDocument
            close={() => setIsDocumentModalOpen(false)}
            subjectId={location.state.classData.subject.id}
            currentPage={targetOrder}
            classroomId={classroomInfo.id}
            getApi={() => {
              getApi()
              setSelectedSlide([])
              setIsSelectedMode(false)
            }}
            setCurrentPage={setCurrentPage}
          />
        </div>
      )}
      {isBoardModalOpen && (
        <LoadBoard
          close={() => setIsBoardModalOpen(false)}
          courseId={location.state.sessionData.courseId}
          currentPage={targetOrder}
          classroomId={classroomInfo.id}
          getApi={() => {
            getApi()
            setSelectedSlide([])
            setIsSelectedMode(false)
          }}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isDeleteModalOpen && (
        <DefaultModal
          content={'delete'}
          close={() => setIsDeleteModalOpen(false)}
          api={() => deleteClassRoomBoardApi(selectedSlide)}
        />
      )}
    </div>
  )
}
